//aria-label for button
document.addEventListener("DOMContentLoaded", function () {
  const containers = document.querySelectorAll(".text-lockup");
  containers.forEach(function (container) {
    const heading = container.querySelector("h2");
    const anchor = container.querySelector("a");
    if (heading && anchor) {
      const headingText = heading.textContent.trim();
      const anchorText = anchor.textContent.trim();

      anchor.setAttribute("aria-label", anchorText + ", " + headingText);
    }
  });
});

//slick slider
$(document).ready(function () {
  $(".slick-dots li button")
    .attr("aria-hidden", "true")
    .attr("role", "presentation");
});

///add aria-hidden="true" on all br tags
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("br, hr").forEach(function (br) {
    br.setAttribute("aria-hidden", "true");
  });
});

///Below product shop all link label
document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector(
    "body#beach-state .component-footer a.component-footer-button.cta.cta-inline",
  );

  if (btn) {
    btn.setAttribute("aria-label", "Shop All, Beach State | Premium Beachware");
  }
});

///3rd btn
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(
    "body#beach-state a.component-footer-button.cta.cta-full.cta-md-inline",
  );

  buttons.forEach((btn) => {
    btn.setAttribute("aria-label", "Shop All, Beach State Product Type");
  });
});

//pdf label
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(
    "body#careers a.block-button.cta.cta-full.cta-md-inline",
  );

  buttons.forEach((btn) => {
    btn.setAttribute(
      "aria-label",
      "Learn more about Picnic Time Family Of Brands Company Culture Book",
    );
  });
});

///Faqs accordion button "Collapsed Expand"
$(document).on("click", ".question-heading", function () {
  $(this).attr("aria-expanded", $(this).hasClass("expanded"));
});

///back to top button
document.addEventListener("DOMContentLoaded", function () {
  var backToTopButton = document.getElementById("back-to-top");
  window.onscroll = function () {
    if (window.pageYOffset > 300) {
      backToTopButton.style.display = "block";
    } else {
      backToTopButton.style.display = "none";
    }
  };
  backToTopButton.onclick = function (e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
    window.setTimeout(function () {
      document.getElementById("top-back").focus();
    }, 600);
  };
});

//inactive phone number
$(document).ready(function () {
  // Match phone numbers like (888) 742-6429
  const phoneRegex = /\(\d{3}\)\s*\d{3}-\d{4}/g;

  function convertPhoneNumbers(element) {
    $(element)
      .contents()
      .each(function () {
        // Skip if already inside a link
        if ($(this).parent().is("a")) return;

        if (this.nodeType === 3) {
          let text = this.nodeValue;
          let matches = text.match(phoneRegex);

          if (matches) {
            let newHTML = text;

            matches.forEach(function (match) {
              // Remove all non-digits for href
              let cleaned = match.replace(/\D/g, ""); // "8887426429"

              // Create tel link with visible number unchanged
              // and aria-label="Phone Number, (888) 742-6429"
              let telLink = `<a href="tel:+1${cleaned}" aria-label="Phone Number, ${match}">${match}</a>`;

              newHTML = newHTML.replace(match, telLink);
            });

            $(this).replaceWith(newHTML);
          }
        } else {
          convertPhoneNumbers(this);
        }
      });
  }

  convertPhoneNumbers(document.body);
});

document.addEventListener("DOMContentLoaded", function () {
  // Select all links inside the given container
  const links = document.querySelectorAll(".pdp-details-outro.body1 p a");

  links.forEach((link) => {
    if (
      link.hasAttribute("target") &&
      link.getAttribute("target") === "_blank"
    ) {
      link.removeAttribute("target");
    }
  });
});

///target blank remove from logo
document.addEventListener("DOMContentLoaded", function () {
  // Function to remove target="_blank" from relevant links
  function removeTargetBlank() {
    const logoLinks = document.querySelectorAll(
      ".col-6.col-lg-4.position-unset-lg .logo a",
    );
    logoLinks.forEach((link) => {
      if (
        link.hasAttribute("target") &&
        link.getAttribute("target") === "_blank"
      ) {
        link.removeAttribute("target");
      }
    });
  }

  // Initial run
  removeTargetBlank();

  // Create a MutationObserver to watch for added nodes
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        removeTargetBlank();
      }
    });
  });

  // Observer configuration
  observer.observe(document.body, {
    childList: true, // watch for added/removed child nodes
    subtree: true, // watch all descendants
  });
});

///increase decrease quantity
document.addEventListener("DOMContentLoaded", function () {
  // Select the minus button
  const minusBtns = document.querySelectorAll(
    ".pdp-qty .quantity-form.js-qty-wrap.qty-wrap span.min.qty-minus",
  );
  minusBtns.forEach((btn) => {
    btn.setAttribute("role", "button");
    btn.setAttribute("tabindex", "0");
    btn.setAttribute("aria-label", "Decrease Quantity By 1");
  });

  // Select the plus button
  const plusBtns = document.querySelectorAll(
    ".pdp-qty .quantity-form.js-qty-wrap.qty-wrap span.plus.qty-plus",
  );
  plusBtns.forEach((btn) => {
    btn.setAttribute("role", "button");
    btn.setAttribute("tabindex", "0");
    btn.setAttribute("aria-label", "Increase Quantity By 1");
  });
});

///previous slide for product
document.addEventListener("DOMContentLoaded", function () {
  function applyAttributes() {
    const prevArrows = document.querySelectorAll(
      "div#ProductPhoto a.previous-arrow.slick-arrow",
    );

    prevArrows.forEach((el) => {
      el.setAttribute("role", "button");
      el.setAttribute("tabindex", "0");
      el.setAttribute("aria-label", "Previous Slide");
    });
  }

  // Initial run
  applyAttributes();

  // Observe DOM changes
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        applyAttributes();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

///next slide button
document.addEventListener("DOMContentLoaded", function () {
  function applyAttributes() {
    const nextArrows = document.querySelectorAll("a.next-arrow.slick-arrow");

    nextArrows.forEach((el) => {
      el.setAttribute("role", "button");
      el.setAttribute("tabindex", "0");
      el.setAttribute("aria-label", "Next Slide");
    });
  }

  // Run initially
  applyAttributes();

  // Observe DOM changes (for dynamic Slick rendering)
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        applyAttributes();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

///convrt nav into tab panel
document.addEventListener("DOMContentLoaded", function () {
  const tabList = document.querySelector(".pdp-tab-menu");
  const tabs = tabList.querySelectorAll(
    "button.single-tab-header.js_single-tab-header.h3",
  );

  // Make container a tablist
  tabList.setAttribute("role", "tablist");

  tabs.forEach((tab) => {
    const trigger = tab.getAttribute("data-tab-trigger");
    const panelId = `tabpanel-${trigger}`;

    // Assign tab attributes
    tab.setAttribute("role", "tab");
    tab.setAttribute("id", `tab-${trigger}`);
    tab.setAttribute("aria-controls", panelId);
    tab.setAttribute("tabindex", tab.classList.contains("active") ? "0" : "-1");
    tab.setAttribute(
      "aria-selected",
      tab.classList.contains("active") ? "true" : "false",
    );

    // Find corresponding panel
    const panel = document.querySelector(`#${panelId}`);
    if (panel) {
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("id", panelId);
      panel.setAttribute("aria-labelledby", `tab-${trigger}`);
      panel.style.display = tab.classList.contains("active") ? "block" : "none";
    }

    // Click event to switch tabs
    tab.addEventListener("click", () => {
      tabs.forEach((t) => {
        t.classList.remove("active");
        t.setAttribute("aria-selected", "false");
        t.setAttribute("tabindex", "-1");
      });

      tab.classList.add("active");
      tab.setAttribute("aria-selected", "true");
      tab.setAttribute("tabindex", "0");

      // Show/hide panels
      tabs.forEach((t) => {
        const pId = t.getAttribute("data-tab-trigger");
        const panel = document.querySelector(`#tabpanel-${pId}`);
        if (panel) panel.style.display = t === tab ? "block" : "none";
      });

      // Move focus to selected tab
      tab.focus();
    });

    // Keyboard support
    tab.addEventListener("keydown", (e) => {
      let index = Array.from(tabs).indexOf(tab);
      let newIndex;
      if (e.key === "ArrowRight") {
        newIndex = (index + 1) % tabs.length;
        tabs[newIndex].click();
      } else if (e.key === "ArrowLeft") {
        newIndex = (index - 1 + tabs.length) % tabs.length;
        tabs[newIndex].click();
      }
    });
  });
});

//filter expanded collapsed
$(document).ready(function () {
  const target = $("h2.body1.filters-heading");
  const closeBtn = $("#filter-close");
  const panel = $(".filters-panel");
  const delay = 1600; // delay in milliseconds for screen readers

  function updateState(el) {
    const $el = $(el);

    if ($el.hasClass("active")) {
      $el.attr("aria-expanded", "true");

      // Show panel
      panel.css("display", "block");

      // Delay moving focus to close button
      setTimeout(function () {
        closeBtn.focus();
      }, delay);
    } else {
      // Delay collapsing for screen reader
      setTimeout(function () {
        $el.attr("aria-expanded", "false");
      }, delay);

      // Hide panel immediately
      panel.css("display", "none");
    }
  }

  // Initial state
  target.each(function () {
    updateState(this);
  });

  // Watch for class changes
  target.each(function () {
    const el = this;

    const observer = new MutationObserver(function () {
      updateState(el);
    });

    observer.observe(el, {
      attributes: true,
      attributeFilter: ["class"],
    });
  });

  // Close button click
  closeBtn.on("click", function () {
    panel.css("display", "none");
    target.removeClass("active");

    // Delay for screen reader
    setTimeout(function () {
      target.attr("aria-expanded", "false").focus();
    }, 0);
  });

  // ESC key support
  $(document).on("keydown", function (e) {
    if (e.key === "Escape") {
      panel.css("display", "none");
      target.removeClass("active");

      // Delay for screen reader
      setTimeout(function () {
        target.attr("aria-expanded", "false").focus();
      }, delay);
    }
  });
});

///hide label text
$(".js_product-grid-variant-swatch").each(function () {
  var id = $(this).attr("id"); // get input id
  $('label[for="' + id + '"]').attr("aria-hidden", "true"); // hide label from screen reader
});

//search button focus
var lastFocusedElement = null;

// OPEN popup
$(".search .header-icon img").on("click", function () {
  lastFocusedElement = this;

  // wait for popup to open, then move focus inside
  setTimeout(function () {
    $(".search-ui.search-ui-desktop")
      .find('input, button, [tabindex]:not([tabindex="-1"])')
      .first()
      .focus();
  }, 100);
});

// CLOSE popup via close button
$(".search-close").on("click", function () {
  if (lastFocusedElement) {
    $(lastFocusedElement).focus();
  }
});

// CLOSE popup via ESC key
$(document).on("keydown", function (e) {
  if (e.key === "Escape") {
    if ($(".search-ui.search-ui-desktop").is(":visible")) {
      // trigger close (optional if your theme already handles it)
      $(".search-close").click();

      // return focus
      if (lastFocusedElement) {
        $(lastFocusedElement).focus();
      }
    }
  }
});


///mble nav collapsed expand
document.addEventListener("DOMContentLoaded", function () {
  // Only run for mobile devices
  if (window.innerWidth <= 768) {
    const footerItems = document.querySelectorAll(".footer-nav-item.js_footer-top-nav-item");

    footerItems.forEach(function (item) {
      // Add button accessibility attributes
      item.setAttribute("role", "button");
      item.setAttribute("tabindex", "0");
      item.setAttribute("aria-expanded", "false");

      // Toggle aria-expanded on click
      item.addEventListener("click", function () {
        const isExpanded = item.getAttribute("aria-expanded") === "true";
        item.setAttribute("aria-expanded", isExpanded ? "false" : "true");
      });

      // Also allow toggle via keyboard (Enter or Space)
      item.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault(); // prevent scrolling on Space
          item.click();
        }
      });
    });
  }
});

 
$(document).ready(function () {
  var $megaTriggers = $('.nav-level-1-item.js_is-megamenu > .nav-level-1-link');

  // 1. Mega menu open/close on level-1 click
  $megaTriggers.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $trigger = $(this);
    var $parent = $trigger.closest('.nav-level-1-item');
    var $megaMenu = $parent.find('.mega-menu');
    var isOpen = $megaMenu.hasClass('is-open');

    // Close all mega menus
    closeAllMegaMenus();

    // Toggle current
    if (!isOpen) {
      $megaMenu.addClass('is-open').removeClass('d-none');
      $trigger.attr('aria-expanded', 'true');
      $megaMenu.find('.close-button').focus();
    }
  });

  // 2. Close button
  $(document).on('click', '#close-mega-menu', function () {
    var $parent = $(this).closest('.nav-level-1-item');
    closeAllMegaMenus();
    $parent.find('.nav-level-1-link').focus();
  });

  // 3. Click outside
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.nav-level-1-item.js_is-megamenu').length) {
      closeAllMegaMenus();
    }
  });

  // 4. Escape key
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      var $openTrigger = $megaTriggers.filter('[aria-expanded="true"]');
      if ($openTrigger.length) {
        closeAllMegaMenus();
        $openTrigger.focus();
      }
    }
  });

  // 5. Level-2 accordion
  $('.nav-toggle-icon').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $toggle = $(this);
    var $parentLi = $toggle.closest('.nav-level-2-item');
    var $childList = $parentLi.find('.nav-level-3');
    var isExpanded = $toggle.attr('aria-expanded') === 'true';

    // Collapse siblings
    $parentLi.siblings('.nav-level-2-item').each(function () {
      $(this).find('.nav-level-3').slideUp(200);
      $(this).find('.nav-toggle-icon').attr('aria-expanded', 'false');
    });

    if (isExpanded) {
      $childList.slideUp(200);
      $toggle.attr('aria-expanded', 'false');
    } else {
      $childList.slideDown(200);
      $toggle.attr('aria-expanded', 'true');
    }
  });

  // 6. Kill hover
  $('.nav-level-1-item.js_is-megamenu').off('mouseenter mouseleave');

  // Helper
  function closeAllMegaMenus() {
    $('.nav-level-1-item.js_is-megamenu').each(function () {
      $(this).find('.mega-menu').removeClass('is-open').addClass('d-none');
      $(this).find('.nav-level-1-link').attr('aria-expanded', 'false');
    });
  }
});



// new js add for mega menu accessibility in snippet/mega-menu.liquid file
$(document).ready(function () {
  // Delay to run AFTER theme JS finishes binding
  setTimeout(function () {

    // === Selectors ===
    var $allMenuItems = $(
      '.nav-level-1-item.js_is-megamenu, .nav-level-1-item.js_explore-megamenu'
    );
    var $allTriggers = $allMenuItems.children('.nav-level-1-link');

    // === Keyboard-focusable ===
    $allTriggers.attr('tabindex', '0');

    // === Nuke ALL theme handlers ===
    $allMenuItems.off();
    $('.js-brand-hover-trigger').off();
    $('.nav-toggle-icon').off();
    $('.nav-level-2-header').off();

    // Also nuke vanilla JS handlers by cloning
    $('.js-brand-hover-trigger').each(function () {
      var $el = $(this);
      var $clone = $el.clone(true);
      $clone.off();
      $el.replaceWith($clone);
    });

    // Re-grab after clone
    var $toggleIcons = $('.nav-toggle-icon');
    $toggleIcons.attr('tabindex', '0');

    // === 1. Mega menu toggle ===
    $allTriggers.on('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var $trigger = $(this);
      var $parent = $trigger.closest('.nav-level-1-item');
      var isOpen = $parent.hasClass('mega-open');

      closeAll();

      if (!isOpen) {
        $parent.addClass('mega-open');
        $trigger.attr('aria-expanded', 'true');
      }
    });

    // === 2. Mega menu keyboard ===
    $allTriggers.on('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).trigger('click');
      }
    });

    // === 3. Close button ===
    var $closeBtn = $('#close-mega-menu');
    $closeBtn.off().attr('tabindex', '0');

    $closeBtn.on('click', function (e) {
      e.stopImmediatePropagation();
      var $trigger = $(this).closest('.nav-level-1-item').find('.nav-level-1-link');
      closeAll();
      $trigger.focus();
    });

    $closeBtn.on('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).trigger('click');
      }
    });

    // === 4. Click outside ===
    $(document).on('click.megamenu', function (e) {
      if (
        !$(e.target).closest(
          '.nav-level-1-item.js_is-megamenu, .nav-level-1-item.js_explore-megamenu'
        ).length
      ) {
        closeAll();
      }
    });

  // === 5. Escape key — layered ===
$(document).on('keydown.megamenu-escape', function (e) {
  if (e.key !== 'Escape') return;

  e.preventDefault();
  e.stopImmediatePropagation();

  var $focused = $(document.activeElement);

  // Layer 1: Inside level-3 link → close accordion, focus toggle
  if ($focused.closest('.nav-level-3').length) {
    var $parentLi = $focused.closest('.nav-level-2-item');
    $parentLi.removeClass('accordion-open');
    $parentLi.find('.nav-toggle-icon').attr('aria-expanded', 'false').focus();
    return;
  }

  // Layer 2: Inside mega menu OR on level-1 trigger → close everything
  var $openMenu = $('.nav-level-1-item.mega-open');
  if ($openMenu.length) {
    var $trigger = $openMenu.children('.nav-level-1-link');
    // Remove class directly on the live element
    $openMenu[0].classList.remove('mega-open');
    $trigger.attr('aria-expanded', 'false');
    // Reset accordions
    $openMenu.find('.nav-level-2-item').removeClass('accordion-open');
    $openMenu.find('.nav-toggle-icon').attr('aria-expanded', 'false');
    // Focus trigger
    $trigger.focus();
    return;
  }
});

    // === 6. Level-2 accordion — DOCUMENT LEVEL delegation ===
    // Clicking anywhere on the header row OR the toggle icon
   $(document).on('click.accordion', '.nav-level-2-header', function (e) {
  var $target = $(e.target);

  // Agar image link ya uske andar kisi cheez par click hua ho
  // to accordion mat chalao, normal link ko chalne do
  if ($target.closest('a').length && !$target.closest('.mega-nav-link.disabled').length) {
    return;
  }

  e.preventDefault();
  e.stopImmediatePropagation();

  var $header = $(this);
  var $parentLi = $header.closest('.nav-level-2-item');
  var $toggle = $parentLi.find('.nav-toggle-icon');
  var isExpanded = $toggle.attr('aria-expanded') === 'true';

  if (!$parentLi.hasClass('has_children')) return;

  $parentLi.siblings('.nav-level-2-item').each(function () {
    $(this).removeClass('accordion-open');
    $(this).find('.nav-toggle-icon').attr('aria-expanded', 'false');
  });

  if (isExpanded) {
    $parentLi.removeClass('accordion-open');
    $toggle.attr('aria-expanded', 'false');
  } else {
    $parentLi.addClass('accordion-open');
    $toggle.attr('aria-expanded', 'true');
  }
});

    // Accordion keyboard — on toggle icon
    $(document).on('keydown.accordion', '.nav-toggle-icon', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).closest('.nav-level-2-header').trigger('click');
      }
    });

    // === 7. Kill hover via CSS-only (already in CSS above) ===
    $allMenuItems.off('mouseenter mouseleave');

    // === Helper ===
    function closeAll() {
      $allMenuItems.removeClass('mega-open');
      $allTriggers.attr('aria-expanded', 'false');
      $('.nav-level-2-item').removeClass('accordion-open');
      $('.nav-toggle-icon').attr('aria-expanded', 'false');
    }

  }, 100);
});
// new js add for the hover feature in snippet/mega-menu.liquid file
$(document).on('mouseenter', '.nav-level-2-item.js-brand-hover-trigger', function () {
  var $item = $(this);
  var targetId = $item.attr('data-target');
  if (!targetId) return;

  var $megaMenu = $item.closest('.mega-menu');
  var $rightCol = $megaMenu.find('.mega-menu-right');
  var $targetPanel = $rightCol.find('#' + targetId);

  $megaMenu.addClass('is-expanded');
  $rightCol.find('.brand-visual-panel').removeClass('active');
  $targetPanel.addClass('active');
});


///mble menu btn focus
document.addEventListener("DOMContentLoaded", function () {
  const mobileNav = document.querySelector(".mobile-nav.d-lg-none");
  const focusTarget = document.querySelector("#cl-sb-mn");
  const hamburgerBtn = document.querySelector(".button-reset.icon-hamburger.mn-mn-btn");

  if (!mobileNav || !focusTarget || !hamburgerBtn) return;

  const observer = new MutationObserver(() => {
    const isOpen = mobileNav.classList.contains("open");

    if (isOpen) {
      setTimeout(() => {
        requestAnimationFrame(() => focusTarget.focus());
      }, 700); // FIX: slow focus
    } else {
      setTimeout(() => hamburgerBtn.focus(), 300);
    }
  });

  observer.observe(mobileNav, {
    attributes: true,
    attributeFilter: ["class"]
  });

  // FIX: proper close behavior
  focusTarget.addEventListener("click", function () {
    mobileNav.classList.remove("open");
    hamburgerBtn.setAttribute("aria-expanded", "false");

    setTimeout(() => {
      hamburgerBtn.focus();
    }, 300);
  });
});



document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const menuDivs = document.querySelectorAll('div[role="menu"]');

    menuDivs.forEach(function (div) {
      if (!div.textContent.trim() && div.children.length === 0) {
        div.removeAttribute("role");
      }
    });
  }, 2000); 
});


// for the mobile menu
$(document).ready(function () {
  var $mobileMenuWrap = $('.mobile-nav.d-lg-none');
  var $menu = $('#my-menu');
  var $closeBtn = $('#cl-sb-mn');
  var $openBtn = $('.button-reset.icon-hamburger');

  function isMenuOpen() {
    return $mobileMenuWrap.hasClass('open');
  }

  function syncMenuState() {
    if (isMenuOpen()) {
      $menu.attr('aria-hidden', 'false');
      $openBtn.attr('aria-expanded', 'true');
    } else {
      $menu.attr('aria-hidden', 'true');
      $openBtn.attr('aria-expanded', 'false');
    }
  }

  // Initial sync
  syncMenuState();

  // Open button click
  $openBtn.on('click', function () {
    setTimeout(function () {
      syncMenuState();

      if (isMenuOpen()) {
        $closeBtn.focus();
      }
    }, 120);
  });

  // Close button click
  $closeBtn.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    $mobileMenuWrap.removeClass('open');
    syncMenuState();

    setTimeout(function () {
      $openBtn.focus();
    }, 50);
  });

  // Escape key
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && isMenuOpen()) {
      $mobileMenuWrap.removeClass('open');
      syncMenuState();

      setTimeout(function () {
        $openBtn.focus();
      }, 50);
    }
  });

  // Observe class changes
  var target = $mobileMenuWrap.get(0);

  if (target) {
    var observer = new MutationObserver(function () {
      syncMenuState();

      if (isMenuOpen()) {
        setTimeout(function () {
          $closeBtn.focus();
        }, 50);
      }
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
});


// menu for the mobile parent dropdown
$(document).ready(function () {

  function syncExpandedAria() {
    $('.js_mobile-top-nav-item').each(function () {
      var $this = $(this);
      var $trigger = $this.find('.no-link-parent');

      if ($this.hasClass('expanded')) {
        $trigger.attr('aria-expanded', 'true');
      } else {
        $trigger.attr('aria-expanded', 'false');
      }
    });
  }

  // Initial check
  syncExpandedAria();

  // Click ke baad class update hone do, phir aria update karo
  $(document).on('click', '.js_mobile-top-nav-item', function () {
    setTimeout(function () {
      syncExpandedAria();
    }, 50);
  });

  // Agar class JS se dynamically change ho rahi ho to usko bhi detect karo
  $('.js_mobile-top-nav-item').each(function () {
    var target = this;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          syncExpandedAria();
        }
      });
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ['class']
    });
  });

});


// submenu for the mobile dropdown 
$(document).ready(function () {

  function syncChildExpandedAria() {
    $('.js_mobile-nav-item').each(function () {
      var $this = $(this);
      var $trigger = $this.find('.no-link-parent');

      if ($trigger.length) {
        if ($this.hasClass('expanded')) {
          $trigger.attr('aria-expanded', 'true');
        } else {
          $trigger.attr('aria-expanded', 'false');
        }
      }
    });
  }

  // Initial check
  syncChildExpandedAria();

  // Click ke baad class update hone do, phir aria update karo
  $(document).on('click', '.js_mobile-nav-item', function () {
    setTimeout(function () {
      syncChildExpandedAria();
    }, 50);
  });

  // Dynamic class changes bhi detect karo
  $('.js_mobile-nav-item').each(function () {
    var target = this;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          syncChildExpandedAria();
        }
      });
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ['class']
    });
  });

});

///empty links removed
document.querySelectorAll('h3.h5.article-grid-title a, .article-grid-inner a').forEach((a) => {
  const text = a.textContent.trim();
  const href = a.getAttribute('href');

  // remove if empty or invalid link
  if (!text || !href || href.trim() === '' || href === '#') {
    a.remove();
  }
});

///Add role button and aria-label in previous slide
document.addEventListener("DOMContentLoaded", function () {
  function applyAttributes() {
    const prevArrows = document.querySelectorAll(".previous-arrow.slick-arrow");

    prevArrows.forEach((el) => {
      el.setAttribute("role", "button");
      el.setAttribute("tabindex", "0");
      el.setAttribute("aria-label", "Previous Slide");
    });
  }

  // Initial run
  applyAttributes();

  // Observe DOM changes (for dynamic sliders)
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        applyAttributes();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

///h5 change into h2
document.addEventListener("DOMContentLoaded", function () {
  // Ensure this runs only on Careers page
  const isCareersPage = document.body.id === "careers";
  if (!isCareersPage) return;

  const containers = document.querySelectorAll(
    ".body1.block-p.custom-text-color"
  );

  containers.forEach(function (container) {
    const h5Elements = container.querySelectorAll("h5");

    h5Elements.forEach(function (h5) {
      // Create new h2 element
      const h2 = document.createElement("h2");

      // Copy content
      h2.innerHTML = h5.innerHTML;

      // Copy attributes (class, id, etc.)
      Array.from(h5.attributes).forEach((attr) => {
        h2.setAttribute(attr.name, attr.value);
      });

      // Replace h5 with h2
      h5.parentNode.replaceChild(h2, h5);
    });
  });
});

///blog click here label
document.addEventListener("DOMContentLoaded", function () {
  // Run only on specific page
  const isTargetPage =
    document.body.id === "we-39-re-going-big-for-giving-week";

  if (!isTargetPage) return;

  const links = document.querySelectorAll(
    ".col-12.col-lg-6 section.article-body.rte a"
  );

  const ariaText =
    "Click here to view Moorpark Pantry Plus, Redirecting to a third party website (opens in a new tab)";

  links.forEach(function (link) {
    link.setAttribute("aria-label", ariaText);
    link.setAttribute("target", "_blank");
  });
});

///triger aria-label for page playlist
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector("#playlists");
  if (!container) return;

  const headings = Array.from(
    container.querySelectorAll("h2.h3.block-heading.custom-text-color")
  );

  const links = container.querySelectorAll(
    "a.block-button.cta.cta-full.cta-md-inline"
  );

  links.forEach((link) => {
    const linkText = link.textContent.trim();

    // Find the closest preceding heading for this link
    let matchedHeadingText = "";

    headings.forEach((heading) => {
      const position = heading.compareDocumentPosition(link);

      // heading comes before link in DOM
      if (position & Node.DOCUMENT_POSITION_FOLLOWING) {
        matchedHeadingText = heading.textContent.trim();
      }
    });

    const ariaLabel = `${linkText}, ${matchedHeadingText}, redirecting to a third party website (opens in a new tab)`;

    link.setAttribute("aria-label", ariaLabel);
  });
});

///compare value pop-up focus
let lastBtn = null;

const openBtn = document.querySelector('span#open-pricing-modal');
const closeBtn = document.querySelector('span#close-pricing-modal');
const overlay = document.querySelector('.pricing-modal-overlay');

openBtn.addEventListener('click', () => {
  lastBtn = openBtn;

  const timer = setInterval(() => {
    if (overlay.classList.contains('is-active')) {
      closeBtn.focus();
      clearInterval(timer);
    }
  }, 50);
});

closeBtn.addEventListener('click', () => {
  setTimeout(() => {
    if (lastBtn) lastBtn.focus();
  }, 0);
});
